module.exports = __webpack_public_path__ + "img/service.79938c64.jpg";